var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Environment, Type, useSession } from '@lendi/lala-react';
import { LDProvider, useLDClient } from 'launchdarkly-react-client-sdk';
import { getClientId } from '../utils/getClientId';
import { getBrandFromHostname } from '@lendi/lala-utils';
export var LendiLDConsumer = function (_a) {
    // const environment = getEnvironment(); // TODO: A better way to get `type` is to use the `getEnvironment()` method from Acquire team. But they've kept it to themselves in `@lendi/lala-callback-app/src/getEnvironment.ts`. We'll use session's environment for now, but in the futurue ideally we should get it from `getEnvironment()`;
    // const type = getTypeFromHostname(); // TODO: A better way to get `type` is to use the `getTypeFromHostname()` method from Acquire team. But they've kept it to themselves in `@lendi/lala-callback-app/src/getTypeFromHostname.ts`. We'll use session's type for now, but in the futurue ideally we should get it from `getTypeFromHostname()`;
    var children = _a.children, clientId = _a.clientId;
    var _b = useSession(), identity = _b.identity, type = _b.type, _c = _b.brand, brand = _c === void 0 ? getBrandFromHostname() : _c;
    var isTeamView = type === Type.Team;
    var custom = { isTeamView: isTeamView, brand: brand };
    var ldClient = useLDClient();
    React.useEffect(function () {
        if (ldClient) {
            if (identity) {
                ldClient.identify({ key: identity.id, custom: custom });
            }
            else {
                ldClient.identify({ anonymous: true, custom: custom }); // TODO: Funnels 1 uses a magic method to track anonymous user. Consider implementing it here. Docs: https://docs.launchdarkly.com/sdk/client-side/javascript#anonymous-users
            }
        }
        else {
            // Do nothing
        }
    }, [ldClient, identity]);
    return React.createElement(React.Fragment, null, children);
};
/**
 * LendiLDProvider
 *
 * This Provider utilzes the session from `@lendi/lala-react` to identify user to LaunchDarkly platform. It'll work for app behind authentication. (Qualis, Submissions)
 *
 * @param clientId In case application wish to provide a custom clientId
 * @param children
 * @constructor
 */
export function LendiLDProvider(_a) {
    var children = _a.children, clientId = _a.clientId;
    var _b = useSession().environment /* Use `environment` from `session` if available, otherwise default to Development */, environment = _b === void 0 ? Environment.Development : _b /* Use `environment` from `session` if available, otherwise default to Development */;
    var launchdarklyClientId = clientId || getClientId(environment);
    var options = {}; // TODO: Set Options
    var reactOptions = {}; // TODO: Set React Options
    return (React.createElement(LDProvider, { clientSideID: launchdarklyClientId, options: options, reactOptions: reactOptions },
        React.createElement(LendiLDConsumer, null, children)));
}
export var withLendiLDProvider = function (Component) {
    return function (_a) {
        var clientId = _a.clientId, props = __rest(_a, ["clientId"]);
        var environment = useSession().environment;
        if (!environment) {
            return null;
        }
        return (React.createElement(LDProvider, { clientSideID: clientId || getClientId(environment) },
            React.createElement(LendiLDConsumer, null,
                React.createElement(Component, __assign({}, props)))));
    };
};
//# sourceMappingURL=index.js.map